import { IGlobalState } from '../index';

export const selectBanners = (state: IGlobalState) => state.advertising.banners;
